import React, { FC, useState } from 'react';
import styles from './Carousel.module.css';
import generalConfig from '../resources/general.json';

const CarouselComponent: FC<{
    caller?: string;
    numItemsToShow: number;
    children?: React.ReactNode;
    returnToMenuFunction?: () => void;
}> = ({ caller, children, numItemsToShow, returnToMenuFunction }) => {
    const [pageNumber, setPageNumber] = useState(1);

    const componentsArray = React.Children.toArray(children);

    const areMorePages = () => {
        const maxPages = componentsArray.length / numItemsToShow;
        return pageNumber < maxPages;
    };

    const getCareCardSubset = () => {
        let subset;
        if (pageNumber === 1) {
            subset = componentsArray.slice(0, numItemsToShow);
        } else {
            subset = componentsArray.slice(
                pageNumber * numItemsToShow - numItemsToShow,
                pageNumber * numItemsToShow
            );
        }
        return subset;
    };

    return (
        <div className="carousel">
            {getCareCardSubset()}
            <div className={styles.carouselNavigationTextContainer}>
                {(caller === 'clinics' || pageNumber > 1) && (
                    <p
                        className={styles.carouselNavigationTextPrev}
                        aria-label={generalConfig.providence.carouselViewPrevious.toLowerCase()}
                        onClick={() => [
                            pageNumber === 1 &&
                            caller === 'clinics' &&
                            returnToMenuFunction
                                ? returnToMenuFunction()
                                : setPageNumber(pageNumber - 1),
                        ]}
                    >
                        {generalConfig.providence.carouselViewPrevious}
                    </p>
                )}
                {areMorePages() && (
                    <p
                        className={styles.carouselNavigationTextNext}
                        aria-label={generalConfig.providence.carouselViewMore.toLowerCase()}
                        onClick={() => [setPageNumber(pageNumber + 1)]}
                    >
                        {generalConfig.providence.carouselViewMore}
                    </p>
                )}
            </div>
        </div>
    );
};

export const Carousel = CarouselComponent;
